import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ContentBlock } from 'app/shared/content-block/content-block';
import { ConfigService } from 'app/core/config.service';

@Injectable()
export class ContentBlockService {
  constructor(private http: HttpClient, private configService: ConfigService) { }

  getContentBlocks(name: string): Observable<ContentBlock[]> {
    return this.configService.getConfigAsync().pipe(
      switchMap(config => 
        this.http.get<ContentBlock[]>(config.portalApiEndpoint + `contentblock/${name}`)
      )
    );
  }

  getDocument (id: string) {
    return this.configService.getConfigAsync().pipe(
      switchMap(config => 
        this.http.get(config.portalApiEndpoint + `contentblock/template/${id}`,
          { responseType: 'blob' })
      )
    );
  }
}
